module.exports = __webpack_public_path__ + "static/media/al.28f256ef.svg";